module.exports = __webpack_public_path__ + "img/chevron-left.c7552ce8.svg";